import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, forwardRef } from 'react'

//export default function ButtonTextIcon({text, icon, iconSize, ...restProps}) {
//const ButtonTextIcon = ({text, icon, iconSize, ...restProps}) => {
const ButtonTextIcon = forwardRef((props,ref) => {
    //console.log(props);
    const onButtonClicked = (e) => {
      console.log("onButtonClicked (ButtonTextIcon)", e.target)    
      // safari is not 'focusing' the button when its pressed
      e.target.focus();

      if(props.onClick) props.onClick()
    };

    const onBlurFocus = () => {
      //console.log("onBlurFocus ButtonTextIcon", props.blurEvent)
      if(props.blurEvent) props.blurEvent()
    };

  return (
    //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
    // hover:underline hover:decoration-2 hover:underline-offset-8 
    <button id={ (props.id) ? props.id : ''} tabIndex={props.tabIndex} className="mb-3 flex flex-row items-center justify-center h-12 opacity-100 transition duration-200 " onClick={onButtonClicked} onBlur={onBlurFocus} >
    {/* <button tabIndex={props.tabIndex} className="mb-3 flex flex-row items-center justify-center h-12 opacity-100 decoration-black/[0.0] underline decoration-2 underline-offset-8 transition duration-500 hover:decoration-black/[1.0]" onClick={props.onClick} > */}
        {props.text != "" ?
          <div className={(props.textClr) ? props.textClr + " grow px-3 font-bold pointer-events-none" : " grow px-3 font-bold pointer-events-none"}>{props.text}</div>
          :
          <div className="grow px-1 font-bold pointer-events-none"></div>
        }
        {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
        {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
        { props.icon &&
          <img className="mr-2 pointer-events-none" src={props.icon} alt={props.iconAlt} width={props.iconSize} height={props.iconSize} />
        }
    </button>
  )
})

const ButtonTextIconWhiteHover = forwardRef((props,ref) => {
  //console.log(props);
return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  <button tabIndex={props.tabIndex} className="mb-3 flex flex-row items-center justify-center h-12 opacity-100 transition duration-500 underline decoration-2 underline-offset-8 decoration-white/[0.0] hover:decoration-white/[1.0]" onClick={props.onClick} >
  {/* <button tabIndex={props.tabIndex} className="mb-3 flex flex-row items-center justify-center h-12 opacity-100 decoration-black/[0.0] underline decoration-2 underline-offset-8 transition duration-500 hover:decoration-black/[1.0]" onClick={props.onClick} > */}
      {props.text != "" ?
        <div className="grow px-3 font-bold ">{props.text}</div>
        :
        <div className="grow px-1 font-bold "></div>
      }
      {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
      {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
      <img className="mr-2 " src={props.icon} alt={props.iconAlt} width={props.iconSize} height={props.iconSize} />
  </button>
)
})

{/* <div className="text-black bg-white h-[44px]">
                    <ButtonTextIcon text="Options" icon={optionsIcon} iconSize="32" onClick={toggleAudio} tabIndex="2"/>
                  </div> */}
const ButtonStatesTextIcon = forwardRef((props,ref) => {
  
  // the button needs to have 2 visual states
  const [isStateActive, setIsStateActive] = useState(false);
  const [isHover, setIsHover] = useState(false);

  const onButtonClicked = (e) => {
    let v = !isStateActive
    setIsStateActive(v)
    console.log("onButtonClicked (ButtonStatesTextIcon)", v, e.target)    
    // safari is not 'focusing' the button when its pressed
    e.target.focus();

    props.onClick()

    //console.log("onBlurOptions", document.activeElement, document.activeElement.id)
    // setTimeout(() => {
    //   console.log("onButtonClicked blurtimeout test", document.activeElement, document.activeElement.id)
    // }, 250);
  };

  const onBlurFocus = () => {
    //console.log("onBlurFocus", props.blurEvent)
    if(props.blurEvent) props.blurEvent()
  };

  // const onFocusTest = (e) => {
  //   console.log("onFocusTest", e.target)
  // };

  useEffect(() => {
    console.log("ButtonStatesTextIcon:", props)
    if(props) {
      // do we have initState?
      if(props.initState) {
        setIsStateActive(true)
      } else {
        console.log("no init state provided- ignore")
      }
    }
  }, []);

return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  //   <div className={!isStateActive ? "text-black bg-white h-[44px] opacity-100 transition duration-200" : "text-white bg-rba-gray-options h-[44px] w-[227px] opacity-100 transition duration-200"} >
  // onFocus={ ()=> console.log("onFocus event")} 
  <div className={!isHover ? "text-black bg-white h-[44px] " : "text-white bg-rba-gray-options h-[44px] "} >
    <button id={ (props.id) ? props.id : ''} tabIndex={props.tabIndex} className="mb-3 flex flex-row items-center justify-center h-11 " aria-expanded={isStateActive} onClick={onButtonClicked}  onMouseEnter={()=> setIsHover(true)} onMouseLeave={()=> setIsHover(false)} onBlur={onBlurFocus} >
        {!isStateActive  ? 
          <img className="ml-3 pointer-events-none" src={ !isHover ? props.icon : props.iconHover} alt={props.iconAltText} width={props.iconSize} height={props.iconSize} />
          // !isHover ? 
          //   <img className="mr-3" src={props.icon} alt="" width={props.iconSize} height={props.iconSize} />
          // : <img className=" mr-3 " src={props.iconHover} alt="" width={props.iconSizeAlt} height={props.iconSizeAlt} />
        :
        <img className=" ml-3 pointer-events-none" src={!isHover ? props.iconAlt : props.iconHoverAlt} alt={props.iconAltText} width={props.iconSizeAlt} height={props.iconSizeAlt} />  }

        {props.text != "" ?
          <div className="grow pl-[10px] pr-[18px] font-bold pointer-events-none">{!isStateActive ? props.text : props.textAlt}</div>
          :
          <div className="grow pl-1 font-bold pointer-events-none"></div>
        }
        {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
        {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
        {/* <img className={!isStateActive ? "mr-2": "invert mr-2"}  src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
        
    </button>
    {/* { (props.initState) ? "OO" : "CC"} */}
  </div>
)
})

// same as above but full width
const ButtonStatesFullWidthTextIcon = forwardRef((props,ref) => {
  
  // the button needs to have 2 visual states
  const [isStateActive, setIsStateActive] = useState(false);
  //const [isHover, setIsHover] = useState(false);

  const onButtonClicked = () => {
    let v = !isStateActive
    setIsStateActive(v)
    console.log("onButtonClicked", v)
    props.onClick()
  };

  useEffect(() => {
    console.log("ButtonStatesTextIcon:", props)
    if(props) {
      // do we have initState?
      if(props.initState) {
        setIsStateActive(true)
      } else {
        console.log("no init state provided- ignore")
      }
    }
  }, []);

return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  //   <div className={!isStateActive ? "text-black bg-white h-[44px] opacity-100 transition duration-200" : "text-white bg-rba-gray-options h-[44px] w-[227px] opacity-100 transition duration-200"} >
  //hover:text-white hover:bg-rba-gray-options
  <div className={!isStateActive ? "text-white bg-rba-gray-options h-[44px] w-full " : "text-white bg-rba-gray-options h-[44px] w-full "} >
    <button id={ (props.id) ? props.id : ''} tabIndex={props.tabIndex} className="mb-3 flex flex-row items-center justify-center h-11 w-full " onClick={onButtonClicked}  >
        {props.text != "" ?
          <div className="grow px-3 font-bold">
            
            {!isStateActive ? <img className="mr-3 inline" src={props.icon} alt="" width={props.iconSize} height={props.iconSize}  /> : <img className=" mr-3 inline " src={props.iconAlt} alt="" width={props.iconSizeAlt} height={props.iconSizeAlt} />}
            {!isStateActive ? props.text : props.textAlt} 
          </div>
          :
          <div className="grow px-1 font-bold"></div>
        }
        {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
        {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
        {/* <img className={!isStateActive ? "mr-2": "invert mr-2"}  src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
        {/* {!isStateActive ? 
        <img className="mr-2" src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} />
        :
        <img className=" mr-2 invert" src={props.iconAlt} alt="icon" width={props.iconSizeAlt} height={props.iconSizeAlt} />} */}
    </button>
  </div>
)
})

const ButtonIcon = forwardRef((props,ref) => {
  const imageCN = `mr-2 ml-2 ${props.className}`; //mr-2 ml-2
  //console.log(props);
return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  <button tabIndex={props.tabIndex} className="mb-1 flex flex-row items-center justify-center h-12 opacity-100 transition duration-200 hover:opacity-100" onClick={props.onClick}>
      {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
      {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
      <img className={imageCN} src={props.icon} alt={props.iconAlt} width={props.iconSize} height={props.iconSize} />
  </button>
)
})

const ButtonHoverIcon = forwardRef((props,ref) => {
  const [isHover, setIsHover] = useState(false);

  const imageCN = `mr-2 ml-2 ${props.className}`; //mr-2 ml-2
  //console.log(props);
return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  <button tabIndex={props.tabIndex} className="mb-1 flex flex-row items-center justify-center h-12 opacity-100 transition duration-200 hover:opacity-100" onClick={props.onClick} onMouseEnter={()=> setIsHover(true)} onMouseLeave={()=> setIsHover(false)} >
      {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
      {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
      {!isHover ? 
      <img className={imageCN} src={props.icon} alt={props.iconAlt} width={props.iconSize} height={props.iconSize} />
      :
      <img className={imageCN} src={props.iconHover} alt={props.iconAlt} width={props.iconSize} height={props.iconSize} />
      }
  </button>
)
})

const ButtonIconDisabled = forwardRef((props,ref) => {
  //console.log(props);
return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  <button tabIndex={props.tabIndex} className="mb-1 flex flex-row items-center justify-center h-12 opacity-50" >
      {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
      {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
      <img className="mr-2 ml-2" src={props.icon} alt={props.iconAlt} width={props.iconSize} height={props.iconSize} />
  </button>
)
})

const OutlineButtonTextIcon = forwardRef((props,ref) => {
  //console.log(props);
return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  <button className="border-2 w-[18rem] mb-3 flex flex-row items-center justify-center h-16 opacity-100 transition duration-500 underline decoration-2 underline-offset-4 decoration-white/[0.0] hover:decoration-white/[1.0] " onClick={props.onClick}>
      <div className="grow px-3 font-bold">{props.text}</div>
      {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
      {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
      <img className="mr-4" src={props.icon} alt={ props.iconAlt} width={props.iconSize} height={props.iconSize} />
  </button>
)
})

// hacked button just for linehight 
const OutlineButtonTextIconAlt = forwardRef((props,ref) => {
  //console.log(props);
return (
  //<button className="border-2 max-w-[15rem] mb-3 flex flex-row items-center justify-center h-16" {...restProps}>
  <button className="border-2 w-[18rem] mb-3 flex flex-row items-center justify-center h-16 opacity-100 transition duration-500 underline decoration-2 underline-offset-4 decoration-white/[0.0] hover:decoration-white/[1.0] " onClick={props.onClick}>
      <div className="grow px-3 font-bold leading-[1.2rem] ">{props.text}</div>
      {/* <ScrollDownIcon className="flex-none h-16" stroke='white' strokeWidth={3.0} width='32px' height='32px'/> */}
      {/* <img src={props.icon} alt="icon" width={props.iconSize} height={props.iconSize} /> */}
      <img className="mr-4" src={props.icon} alt={ props.iconAlt}  width={props.iconSize} height={props.iconSize} />
  </button>
)
})

export {
  ButtonTextIcon,
  ButtonStatesTextIcon,
  ButtonTextIconWhiteHover,
  ButtonStatesFullWidthTextIcon,
  ButtonIcon,
  ButtonHoverIcon,
  ButtonIconDisabled,
  OutlineButtonTextIcon,
  OutlineButtonTextIconAlt
}

//       <div className="flex w-full h-displayHt flex-col items-center justify-center bg-slate-300">{children}</div>

// const Link = forwardRef((props,ref) => {
//     // const Link = ({ children, href }) => {
//       const router = useRouter()
//       return (
//         <a
//           ref={ref}
//           href="#"
//           onClick={(e) => {
//             e.preventDefault()
//             // typically you want to use `next/link` for this usecase
//             // but this example shows how you can also access the router
//             // and use it manually
//             router.push(href)
//           }}
//         >
//           {props.children}
//           {/* <style jsx>{`
//             a {
//               margin-right: 10px;
//             }
//           `}</style> */}
//         </a>
//       )
//     })
    